import { combineReducers } from 'redux';

import {
  PURCHASE_GET_LOADING,
  PURCHASE_GET_ERROR,
  PURCHASE_GET_SUCCESS,

  PURCHASE_VIEW_ERROR,
  PURCHASE_VIEW_LOADING,
  PURCHASE_VIEW_SUCCESS,

  PURCHASE_ADD_ERROR,
  PURCHASE_ADD_LOADING,
  PURCHASE_ADD_SUCCESS,

  PURCHASE_DELETE_ERROR,
  PURCHASE_DELETE_LOADING,
  PURCHASE_DELETE_SUCCESS,
  PURCHASE_CANCEL
} from '../actions/constant';

import {
  LIST_PORT_GET_LOADING,
  LIST_PORT_GET_SUCCESS,
  LIST_PORT_GET_ERROR,

  LIST_JENIS_USER_CONSIGNE_GET_LOADING,
  LIST_JENIS_USER_CONSIGNE_GET_SUCCESS,
  LIST_JENIS_USER_CONSIGNE_GET_ERROR,
} from '../actions/purchaseAction';

const purchaseCancel = (state = false, action) => {
  switch (action.type) {
    case PURCHASE_CANCEL:
      return action.purchaseCancelSuccess;
    default:
      return state;
  }
};

const purchaseGetError = (state = false, action) => {
  switch (action.type) {
    case PURCHASE_GET_ERROR:
      return action.purchaseGetError;
    default:
      return state;
  }
};

const purchaseGetLoading = (state = false, action) => {
  switch (action.type) {
    case PURCHASE_GET_LOADING:
      return action.purchaseGetLoading;
    default:
      return state;
  }
};

const purchaseUpdateDimensiTonaseReduce = (state = { bolean: false, val: 0 }, action) => {
  switch (action.type) {
    case 'purchaseUpdateDimensiTonaseSuccess':
      return { bolean: action.bolean, val: action.val };
    default:
      return state;
  }
};

const purchasePriceApprove_by_consigneeReduce = (state = { bolean: false, val: 0 }, action) => {
  switch (action.type) {
    case 'PriceApprove_by_consignee':
      return { bolean: action.bolean, val: action.val };
    default:
      return state;
  }
};

const purchaseGetSuccess = (state = false, action) => {
  switch (action.type) {
    case PURCHASE_GET_SUCCESS:
      return action.purchaseGetSuccess;
    default:
      return state;
  }
};

const purchases = (state = [], action) => {
  switch (action.type) {
    case PURCHASE_GET_SUCCESS:
      return action.purchases;
    default:
      return state;
  }
};

const purchaseViewLoading = (state = false, action) => {
  switch (action.type) {
    case PURCHASE_VIEW_LOADING:
      return action.purchaseViewLoading;
    default:
      return state;
  }
};

const purchaseViewError = (state = false, action) => {
  switch (action.type) {
    case PURCHASE_VIEW_ERROR:
      return action.purchaseViewError;
    default:
      return state;
  }
};

const purchaseViewSuccess = (state = false, action) => {
  switch (action.type) {
    case PURCHASE_VIEW_SUCCESS:
      return action.purchaseViewSuccess;
    default:
      return state;
  }
};

const purchase = (state = [], action) => {
  switch (action.type) {
    case PURCHASE_VIEW_SUCCESS:
      return action.purchase;
    default:
      return state;
  }
};

const purchaseAddError = (state = false, action) => {
  switch (action.type) {
    case PURCHASE_ADD_ERROR:
      return action.purchaseAddError;
    default:
      return state;
  }
};

const purchaseAddLoading = (state = false, action) => {
  switch (action.type) {
    case PURCHASE_ADD_LOADING:
      return action.purchaseAddLoading;
    default:
      return state;
  }
};

const purchaseAddSuccess = (state = false, action) => {
  switch (action.type) {
    case PURCHASE_ADD_SUCCESS:
      return action.purchaseAddSuccess;
    default:
      return state;
  }
};

const purchaseAdded = (state = [], action) => {
  switch (action.type) {
    case PURCHASE_ADD_SUCCESS:
      return action.purchase;
    default:
      return state;
  }
};

const purchaseDeleteError = (state = false, action) => {
  switch (action.type) {
    case PURCHASE_DELETE_ERROR:
      return action.purchaseDeleteError;
    default:
      return state;
  }
};

const purchaseDeleteLoading = (state = false, action) => {
  switch (action.type) {
    case PURCHASE_DELETE_LOADING:
      return action.purchaseDeleteLoading;
    default:
      return state;
  }
};

const purchaseDeleteSuccess = (state = false, action) => {
  switch (action.type) {
    case PURCHASE_DELETE_SUCCESS:
      return action.purchaseDeleteSuccess;
    default:
      return state;
  }
};

const PURCHASE_SET_BIAYA = 'PURCHASE_SET_BIAYA';

const purchaseSetBiayaError = (state = false, action) => {
  switch (action.type) {
    case PURCHASE_SET_BIAYA + '_ERROR':
      return action.error;
    default:
      return state;
  }
};


const purchaseSetBiayaLoading = (state = false, action) => {
  switch (action.type) {
    case PURCHASE_SET_BIAYA + '_LOADING':
      return action.loading;
    default:
      return state;
  }
};

const purchaseSetBiayaSuccess = (state = false, action) => {
  switch (action.type) {
    case PURCHASE_SET_BIAYA + '_SUCCESS':
      return action.success;
    default:
      return state;
  }
};

const getListPortLoading = (state = false, action) => {
  switch (action.type) {
    case LIST_PORT_GET_LOADING:
      return action.getListPortLoading;
    default:
      return state;
  }
};

const getListPortSuccess = (state = false, action) => {
  switch (action.type) {
    case LIST_PORT_GET_SUCCESS:
      return action.getListPortSuccess;
    default:
      return state;
  }
};

const getListPortError = (state = false, action) => {
  switch (action.type) {
    case LIST_PORT_GET_ERROR:
      return action.getListPortError;
    default:
      return state;
  }
};

const port = (state = [], action) => {
  switch (action.type) {
    case LIST_PORT_GET_SUCCESS:
      return action.port
    default:
      return state
  }
}

const getJenisUserConsigneLoading = (state = false, action) => {
  switch (action.type) {
    case LIST_JENIS_USER_CONSIGNE_GET_LOADING:
      return action.getJenisUserConsigneLoading;
    default:
      return state;
  }
};

const getJenisUserConsigneSuccess = (state = false, action) => {
  switch (action.type) {
    case LIST_JENIS_USER_CONSIGNE_GET_SUCCESS:
      return action.getJenisUserConsigneSuccess;
    default:
      return state;
  }
};

const getJenisUserConsigneError = (state = false, action) => {
  switch (action.type) {
    case LIST_JENIS_USER_CONSIGNE_GET_ERROR:
      return action.getJenisUserConsigneError;
    default:
      return state;
  }
};

const jenisUserConsigne = (state = [], action) => {
  switch (action.type) {
    case LIST_JENIS_USER_CONSIGNE_GET_SUCCESS:
      return action.jenisUserConsigne
    default:
      return state
  }
}

const purchaseReducer = combineReducers({
  purchaseCancel,
  purchaseGetError,
  purchaseGetLoading,
  purchaseGetSuccess,
  purchases,

  purchaseViewLoading,
  purchaseViewError,
  purchaseViewSuccess,
  purchase,

  purchaseAddError,
  purchaseAddLoading,
  purchaseAddSuccess,
  purchaseAdded,

  purchaseDeleteError,
  purchaseDeleteLoading,
  purchaseDeleteSuccess,

  purchaseUpdateDimensiTonaseReduce,
  purchasePriceApprove_by_consigneeReduce,

  purchaseSetBiayaLoading,
  purchaseSetBiayaError,
  purchaseSetBiayaSuccess,

  getListPortLoading,
  getListPortSuccess,
  getListPortError,
  port,

  getJenisUserConsigneLoading,
  getJenisUserConsigneSuccess,
  getJenisUserConsigneError,
  jenisUserConsigne,
});

export default purchaseReducer;
